import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../../Localization.jsx"
import EditLocaleSettingsPanel from "./EditLocaleSettingsPanel.jsx"

import { Modal, Button, Text, Group } from '@mantine/core';
import { BRAND_PRIMARY } from "../../theme/brandTheme.js";

class EditLocaleDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeTab: 0,
      title: "",
      isDuplicate: false,
      isDuplicateCheckComplete: false,
    };
    // Set while an update request is in flight; see handleUpdateClicked.
    this.pendingLocaleUpdate = null;
    this.previousLocaleBeforeUpdate = null;
    autoBind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.open && !prevState.open) {
      // Dialog has just opened, reset everything and perform check
      this.resetDialogState();
      this.checkIfEpackIsDuplicate();
    }
  }

  resetDialogState() {
    // Always start on first tab and reset duplication state
    const currentLocale = this.props.root.getCurrentLocale();
    this.setState({
      activeTab: 0,
      isDuplicate: false,
      isDuplicateCheckComplete: false,
      title: (currentLocale && currentLocale.name) ? currentLocale.name : "",
    });
    this.state.activeTab = 0;
  }

  checkIfEpackIsDuplicate() {
    const currentLocale = this.props.root.getCurrentLocale();
    if (currentLocale && currentLocale.id) {
      const requestObj = {
        epack_id: currentLocale.id
      };
      this.props.root.refs.API.request("is_epack_duplicate", requestObj, this.onDuplicateCheckSuccess, this.onDuplicateCheckFail);
    } else {
      // This is create mode, not duplicate
      this.setState({
        isDuplicate: false,
        isDuplicateCheckComplete: true,
      });
    }
  }

  onDuplicateCheckSuccess = (response) => {
    const isDuplicate = response && response.body.result && response.body.result.is_duplicate === 1;
    this.setState({
      isDuplicate: isDuplicate,
      isDuplicateCheckComplete: true,
    });
  }

  onDuplicateCheckFail = (err) => {
    // In case of API failure, assume it's not a duplicate and show the control
    console.error("is_epack_duplicate check failed:", err);
    this.setState({
      isDuplicate: false,
      isDuplicateCheckComplete: true,
    });
  }

  changeTab(index) {
    let newIndex = this.state.activeTab;
    if (this.refs.localeDetailView) {
      if (this.refs.localeDetailView.validateInput()) {
        newIndex = index;
      }
    }
    else {
      newIndex = index;
    }
    this.setState({ activeTab: newIndex });
    this.state.activeTab = newIndex;

    if (this.refs.localeDetailView) {
      this.refs.localeDetailView.changeActiveView(newIndex);
    }
    this.props.parent.refs.localeMapState.setBoundsChanged(false);
  }

  handleTabChange = (event, index) => {
    console.log(index.toString());
    this.changeTab(index);
  }

  close() {
    if (this.props.parent.refs.localeMapState) {
      this.props.parent.refs.localeMapState.setBoundsChanged(false);
    }
    // Clear all state when closing
    this.setState({ 
      open: false,
      activeTab: 0,
      isDuplicate: false,
      isDuplicateCheckComplete: false,
    });
    this.state.open = false;
    this.state.activeTab = 0;
  }

  handleClose() {
    if (this.refs.localeDetailView.state.isDirty) {
      let dialogText = {
        title: Localization.strings.UNSAVED_CHANGES,
        content: Localization.strings.UNSAVED_REMINDER,
        confirm: Localization.strings.CONTINUE_EDITING,
        cancel: Localization.strings.DISCARD_CHANGES,
      }
      this.props.root.refs.confirmDialog.show(dialogText, this.closeCancelClicked, this.closeConfirmClicked);
    }
    else {
      this.close();
    }
  }

  closeCancelClicked() {

  }

  closeConfirmClicked() {
    this.close();
  }

  handleCancel() {
    this.handleClose();
  }

  handleUpdateClicked() {
    if (!this.refs.localeDetailView) {
      return;
    }
    this.refs.localeDetailView.syncLocaleGeometryFromBox();
    if (!this.refs.localeDetailView.validateInput()) {
      return;
    }
    let localeDetailViewState = this.refs.localeDetailView.state;
    // update locale info first
    let requestObj = {
        table: "epack",
        where_field: "id",
        where_value: this.props.root.getCurrentLocale().id,
        row: {
          name: localeDetailViewState.localeName,
          description: localeDetailViewState.localeDesc,
          kla: localeDetailViewState.localeKLA,
          subject: localeDetailViewState.localeSubject,
          tn_file_id: localeDetailViewState.localeCoverFileID,
          color: parseInt(localeDetailViewState.localeColor, 16),
          lang: localeDetailViewState.localeLanguage,
          is_share: (localeDetailViewState.localeShareable? 1 : 0),
          is_ready: (localeDetailViewState.localePublish? 1 : 0),
          is_duplication_allowed: localeDetailViewState.localeDuplicationAllowed,
          mid_lat: localeDetailViewState.localeCenter.lat,
          mid_lon: localeDetailViewState.localeCenter.lng,
          ul_lat: localeDetailViewState.localeUpperLeft.lat,
          ul_lon: localeDetailViewState.localeUpperLeft.lng,
          br_lat: localeDetailViewState.localeBottomRight.lat,
          br_lon: localeDetailViewState.localeBottomRight.lng,
          hs_reveal_code: localeDetailViewState.hsRevealCode,
          hs_reveal_code_enabled: (localeDetailViewState.hsRevealCodeEnabled? 1 : 0),
          is_auto_share_assessment: parseInt(localeDetailViewState.autoShareAssessment, 10) || 0,
          // 0 = Automatically must survive; only an explicit 0 maps to 0, everything else defaults to 1 (Manually)
          is_manual_ai_assessment: (parseInt(localeDetailViewState.manualAiAssessment, 10) === 0 ? 0 : 1),
          // Avatar interaction (game mode)
          is_mood_enabled: (localeDetailViewState.moodEnabled ? 1 : 0),
          is_nudge_enabled: (localeDetailViewState.nudgeEnabled ? 1 : 0),
          is_chat_teacher_to_student: (localeDetailViewState.chatTeacherToStudent ? 1 : 0),
          is_chat_student_to_student: (localeDetailViewState.chatStudentToStudent ? 1 : 0),
          is_chat_student_to_teacher: (localeDetailViewState.chatStudentToTeacher ? 1 : 0)
        }
      };
      // Snapshot what the save is about to make true. It has to happen HERE,
      // not in updateLocaleOK: close() below unmounts the panel with the modal,
      // so this.refs.localeDetailView is already gone by the time the response
      // lands. RootPage keeps a single cached locale row and nothing else
      // invalidates it after a save, which is why a replaced cover image kept
      // coming back until the locale was exited and re-entered.
      this.pendingLocaleUpdate = this.buildUpdatedLocale(requestObj.row, localeDetailViewState);
      // Apply the new Field Trip area immediately. HotspotViewerPage stays
      // mounted under this dialog and used to keep dropping hotspots on the
      // previous box until the PATCH came back.
      this.previousLocaleBeforeUpdate = this.props.root.getCurrentLocale()
        ? { ...this.props.root.getCurrentLocale() }
        : null;
      if (this.pendingLocaleUpdate) {
        this.props.parent.updateCurrentLocale(this.pendingLocaleUpdate);
      }

      // does not need to close the dialog here
      this.props.root.refs.API.request("update", requestObj, this.updateLocaleOK, this.updateLocaleFail);

      // update bbox if bbox is dirty
      if (this.props.parent.refs.localeMapState.state.boundsChanged) {
        this.refs.localeDetailView.updateMapState();
        // this.props.parent.createMapTile(localeDetailViewState.localeUpperLeft, localeDetailViewState.localeBottomRight);
      }
      this.close();
      
      if (this.refs.localeDetailView) {
        this.refs.localeDetailView.setState({ isDirty: false });
      }
  }

  // The row we just wrote, merged over the locale the dialog was opened with.
  // The column names in `row` are the epack column names, so they land on the
  // cached row as-is; path/tn_path are joined in from the file table by the
  // list query, so a cover swap has to carry them over by hand.
  buildUpdatedLocale(row, localeDetailViewState) {
    const currentLocale = this.props.root.getCurrentLocale();
    if (!currentLocale) {
      return null;
    }

    return {
      ...currentLocale,
      ...row,
      path: localeDetailViewState.localeCoverRawPath,
      tn_path: localeDetailViewState.localeCoverRawPreviewPath,
    };
  }

  updateLocaleOK(res) {
    if (this.pendingLocaleUpdate) {
      this.props.parent.updateCurrentLocale(this.pendingLocaleUpdate);
      this.pendingLocaleUpdate = null;
    }
    this.previousLocaleBeforeUpdate = null;
    this.props.parent.refreshLocaleList();
    this.props.root.addNotification(Localization.strings.UPDATED, true);
    
    var requestObj = {epack_id: this.props.root.getCurrentLocale().id};
    this.props.root.refs.API.request("touch_epack", requestObj);
    // this.close();
  }

  updateLocaleFail(err) {
    // Nothing was written, so the cached locale must keep its pre-save values.
    if (this.previousLocaleBeforeUpdate) {
      this.props.parent.updateCurrentLocale(this.previousLocaleBeforeUpdate);
      this.previousLocaleBeforeUpdate = null;
    }
    this.pendingLocaleUpdate = null;
    console.log("update locale fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED, false);
  }

  downloadMapTileComplete() {
    let epackID = this.props.root.getCurrentLocale().id;
    this.props.parent.uploadMapTile(epackID, true);
  }

  createMapTileDone() {
    let localeDetailViewState = this.refs.localeDetailView.state;
    let requestObj = {
      table: "epack",
      where_field: "id",
      where_value: this.props.root.getCurrentLocale().id,
      row: {
        mid_lat: localeDetailViewState.localeCenter.lat,
        mid_lon: localeDetailViewState.localeCenter.lng,
        ul_lat: localeDetailViewState.localeUpperLeft.lat,
        ul_lon: localeDetailViewState.localeUpperLeft.lng,
        br_lat: localeDetailViewState.localeBottomRight.lat,
        br_lon: localeDetailViewState.localeBottomRight.lng,
      }
    };
    this.props.root.refs.API.request("update", requestObj, this.updateLocaleOK, this.updateLocaleFail);
  }

  onBoundsChanged() {
    this.props.parent.refs.localeMapState.setBoundsChanged(true);
  }

  render() {
    return (
      <div>
        <Modal
          opened={this.state.open}
          onClose={this.handleClose}
          withCloseButton={false}
          padding={0}
          size="min(1200px, 94vw)"
          centered
          zIndex={2000}
          styles={{
            content: { height: '85vh', display: 'flex', flexDirection: 'column' },
            body: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', padding: 0 },
          }}
        >
          <Group
            justify="flex-start"
            px="md"
            style={{ height: 56, flexShrink: 0, backgroundColor: BRAND_PRIMARY }}
          >
            <Text c="white" fw={600}>
              {Localization.strings.EDIT + " - " + this.state.title}
            </Text>
          </Group>

          <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
            <EditLocaleSettingsPanel
              key={this.props.root.getCurrentLocale() ? this.props.root.getCurrentLocale().id + '_' + this.state.open : 'edit-dialog'}
              root={this.props.root}
              parent={this}
              ref="localeDetailView"
              epackID={this.props.root.getCurrentLocale() ? this.props.root.getCurrentLocale().id : ""}
              isDuplicate={this.state.isDuplicate}
              isDuplicateCheckComplete={this.state.isDuplicateCheckComplete}
            />
          </div>

          <Group justify="flex-end" style={{ padding: '16px', flexShrink: 0, borderTop: '1px solid #e9ecef' }}>
            <Button
              variant="default"
              onClick={this.handleCancel}
            >
              {Localization.strings.CANCEL}
            </Button>
            <Button
              onClick={this.handleUpdateClicked}
            >
              {Localization.strings.UPDATE}
            </Button>
          </Group>
        </Modal>
      </div>
    )
  }
}

export default EditLocaleDialog;
